// Groww-style mover lists from a board snapshot.
import type { Analysed, Snapshot } from '@planb/core';
import { liveSweep } from '@/charts/board';

export type MoverList = 'bulls' | 'bears' | 'sweeps' | 'volume' | 'flow';

export const MOVER_LISTS: { id: MoverList; label: string; blurb: string }[] = [
  { id: 'bulls', label: 'Strongest bullish', blurb: 'Rising stocks ranked by strength: move vs usual range, volume, VWAP hold and open-interest confirmation.' },
  { id: 'bears', label: 'Strongest bearish', blurb: 'Falling stocks ranked the same way.' },
  { id: 'sweeps', label: 'Fresh sweeps', blurb: 'Price poked past an obvious high or low in the last hour, then closed back inside.' },
  { id: 'volume', label: 'Volume shockers', blurb: 'Trading far more than usual for this time of day.' },
  { id: 'flow', label: 'Order-flow leaders', blurb: 'The most one-sided estimated buying or selling (needs the live feed).' },
];

export function moverList(snap: Snapshot, list: MoverList): Analysed[] {
  switch (list) {
    case 'bulls': return snap.bulls;
    case 'bears': return snap.bears;
    case 'sweeps': return snap.stocks
      .filter((s) => liveSweep(s, snap.t))
      .sort((p, q) => liveSweep(q, snap.t)!.idx - liveSweep(p, snap.t)!.idx || q.score - p.score);
    case 'volume': return snap.stocks.filter((s) => s.relVol >= 1.2).sort((p, q) => q.relVol - p.relVol);
    case 'flow': return snap.stocks.filter((s) => s.flow).sort((p, q) => Math.abs(q.flow!.deltaPct) - Math.abs(p.flow!.deltaPct));
  }
}
